import { getPublicConfig, type SubscriptionPlan } from "~/public-config";

const config = getPublicConfig();

export function getDefaultMapStyle() {
  return config.aws.maps["EsriNavigation"] as MapStyle;
}

export type StripeSubscriptionStatus =
  | "trialing"
  | "active"
  | "past_due"
  | "canceled"
  | "unpaid"
  | "incomplete"
  | "incomplete_expired"
  | "paused";

export type SubscriptionInfo = {
  plan: SubscriptionPlan;
  status: StripeSubscriptionStatus;
};

export const planLevels = {
  contractor: 1,
  acquisition: 2,
  rezoning: 3,
} as const;

export type MapStyle = (typeof config.aws.maps)[keyof typeof config.aws.maps];
export type AllowedFonts = NonNullable<MapStyle["fonts"][number]>;

/** Coordinates in the form of `[west, south, east, north]` to form a max bounding box */
export type FlatBbox = [number, number, number, number];

export type InitialMapOptions = {
  /** Initial Map zoom level */
  zoom: number;
  /** The minimum zoom level of the map (0-24). Default is `0` */
  minZoom: number;
  /** The maximum zoom level of the map (0-24). Default is `22` */
  maxZoom: number;
  /** Coordinates in the form of `[west, south, east, north]` to form a max bounding box for the visual map */
  maxBounds: FlatBbox;
  /** Coordinates in the form of `[west, south, east, north]` to form a max bounding box for the search functionality */
  searchBounds: FlatBbox;
  /** Initial latitude value for the map to begin at */
  lat: number;
  /** Initial longitude value for the map to begin at */
  lng: number;
};
